export default {
  submitBtn: false,
  emptyBtn: false,

  column: [
    {
      label: '上级节点',
      prop: 'parentName',
      display: true,
      formslot: true,
      span: 12,
    },
    {
      label: '上级属性',
      prop: 'parentParkTypeName',
      display: true,
      formslot: true,
      readonly: true,
      span: 12,
    },
    {
      label: '车位编号',
      prop: 'parkSpaceNo',
      display: true,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请输入车位编号',
          trigger: 'change',
        },
      ],
      span: 12,
    },
    {
      label: '车位状态',
      prop: 'carParkStatus',
      formslot: true,
      display: true,
      span: 12,
    },
  ],
};
